import { useEffect } from 'react'
import { ContentStateInterface } from '../../../../@types/types'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { fetchPriceMaximizerDataIfValid } from '../../../../redux/thunks/priceMaximizer/fetchPriceMaximizerDataIfValid'
import { getDefaultLogger } from '../../../../services/logger/logger'

export function useLoadPriceMaximizerData(insertionData: ContentStateInterface, enabled: boolean = true) {
  const addressFeature = useAppSelector((state: InitState) => state.addressFeature)
  const validationSchema = useAppSelector((state: InitState) => state.flowFeature.flowInformation.validationSchema)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!enabled) {
      return
    }

    const fetch = async () => {
      await dispatch(fetchPriceMaximizerDataIfValid(insertionData, addressFeature, validationSchema))
    }

    fetch().catch(getDefaultLogger().error)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enabled,
    insertionData.price,
    insertionData.additionalCosts,
    insertionData.heatingCosts,
    insertionData.room,
    insertionData.livingSpace,
    insertionData.plotArea,
    insertionData.manualCity?.value,
    insertionData.manualRegion?.value,
    insertionData.manualQuarter?.value,
    addressFeature.geoCoordinates.lambertEuCoordinatesX,
    addressFeature.geoCoordinates.lambertEuCoordinatesY,
    addressFeature.geoCoordinates.longitude,
    addressFeature.geoCoordinates.latitude,
    dispatch,
  ])
}
